(app => {

    app.controller("addPipelineController", addPipelineController);

    function addPipelineController($mdDialog, $state, pipelineApi) {
        var $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.pipeline = {};
        }

        $ctrl.close = () => {
            $mdDialog.hide();
        };

        $ctrl.addPipeline = (pipeline) => {
            $ctrl.loading = true;

            pipelineApi.add(pipeline).then(response => {
                $state.go("Home.Marketing.Pipeline", { pipelineId: response.Id }, { reload: true });

                $ctrl.close();
            });
        }
    }

})(window.app); //jshint ignore:line